// angular dependencies
import { ENVIRONMENT_INITIALIZER, inject, NgModule } from '@angular/core';

// third-party dependencies
import { EffectsModule } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';

// fantaz dependencies
import { AuthServiceInjectionToken } from '@fantaz/shared/data-access/api';
import {
  AUTH_FEATURE_KEY,
  AuthActions,
  AuthEffects,
  AuthFacade,
  sharedAuthReducer,
} from './+state';
import { AuthGuard } from './guards';

@NgModule({
  imports: [
    StoreModule.forFeature(AUTH_FEATURE_KEY, sharedAuthReducer),
    EffectsModule.forFeature([AuthEffects]),
  ],
  providers: [
    AuthFacade,
    AuthGuard,
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () => {
        const _store = inject(Store);
        const _authService = inject(AuthServiceInjectionToken);

        // Listen to the auth state
        _authService.onAuthStateChanged((authState: any) => {
          if (
            authState?.payload.event === 'signedIn' ||
            authState?.payload.event === 'tokenRefresh'
          ) {
            const rememberDevice = localStorage.getItem('rememberDevice');
            if (rememberDevice !== 'true') {
              _store.dispatch(AuthActions.loadAuthSession());
            }
          }
        });
      },
    },
  ],
  exports: [StoreModule, EffectsModule],
})
export class SharedAuthModule {}
